export function m2ToHa(input: number): number {
  return Math.round(input / 100) / 100;
}

export function m2ToHaWithDecimals(input: number): number {
  const result = (input / 100 / 100).toFixed(5);
  return parseFloat(result);
}
